// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wAjc","list":"styles_list__DXWZ7","disableSelection":"styles_disableSelection__2hj2z"};